export default "__VITE_ASSET__B3WIdIA0__"